/* eslint-disable global-require */
import angular from 'angular';

class StaticResourceController {
  private staticId!: string;

  public src = '';

  public $onInit = (): void => {
    const BASE_URL = `${API_URL}/static/f/view`;
    this.src = `${BASE_URL}/${this.staticId}`;
  };
}

export const StaticResourceComponent = {
  selector: 'staticResource',
  bindings: {
    staticId: '<',
  },
  template: /* html */ `
    <img ng-src="{{ $ctrl.src }}">
  `,
  controller: StaticResourceController,
};

export default angular.module('autoboard.staticResource', [])
  .component(StaticResourceComponent.selector, StaticResourceComponent)
  .name;
